module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "export-calendar text-dark"
  }, [(_vm.isShowButton) ? _c('button', {
    staticClass: "bttn bttn--is-loading",
    on: {
      "click": function($event) {
        return _vm.setIsModal(true)
      }
    }
  }, [(_vm.calLink === 'loading') ? _c('spinner', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "size": "small",
      "color": "blue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.calLink.length > 0 && _vm.calLink !== 'loading') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.export_calendar')))]) : _vm._e(), _vm._v(" "), (_vm.calLink.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.guide_to_export_calendar')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('d-modal', {
    attrs: {
      "show-close": false
    },
    on: {
      "close": function($event) {
        return _vm.setIsModal(false)
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.setIsModal(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "modal__left"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.export_calendar_to')))]), _vm._v(" "), _c('ul', {
    staticClass: "export-calendar__cals"
  }, _vm._l((_vm.integrations), function(integration) {
    return _c('li', {
      key: integration.id,
      class: {
        'cal--is-active': _vm.theActiveIntegration === integration.id
      },
      on: {
        "click": function($event) {
          _vm.theActiveIntegration = integration.id
        }
      }
    }, [_c('div', {
      staticClass: "integration-img",
      style: ({
        'background-image': 'url(' + integration.icon + ')'
      })
    }), _vm._v("\n              " + _vm._s(integration.title) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "modal__right"
  }, [(_vm.calLink.length > 0) ? [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.copy_the_url_and_insert')))]), _vm._v(" "), _c('input', {
    staticClass: "marg-20-bottom",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.calLink
    },
    on: {
      "click": function($event) {
        return $event.target.select()
      }
    }
  })] : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.calendar_export.guide_to')) + " " + _vm._s(_vm.integrations[_vm.theActiveIntegration].title))]), _vm._v(" "), _vm._l((_vm.integrations[_vm.theActiveIntegration].imgs), function(img) {
    return _c('img', {
      attrs: {
        "src": img,
        "alt": ""
      }
    })
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('div', {
    staticClass: "bg-overlay",
    on: {
      "click": function($event) {
        return _vm.setIsModal(false)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57d78ff0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExportCalendar/ExportCalendar.vue
// module id = 1934
// module chunks = 1